export enum SubmitStatus {
  Pending = 'pending',
  PendingConfirmation = 'pendingConfirmation',
  Submit = 'submit',
  Cancel = 'cancel'
}
